export default __webpack_public_path__ + "locales/uk-UA/Payments.json?hash=93150e81072adabbef0e3163602a10ca";